var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.create)?_c('v-btn',{attrs:{"color":"error","small":""},on:{"click":_vm.click}},[_vm._v(_vm._s(_vm._f("t")(_vm.label)))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }